import { mapGetters } from 'vuex';

import { renderFormulas } from '@/helpers/functions';

import HtmlRenderContainer from '@/components/content-management/html-render-container';

import QuestionsSummary from '@/components/gaia/student/quiz/questions-summary';
import QuizMixin from '@/mixins/quiz';

export default {
  props: {
    isOpen: {
      type    : Boolean,
      default : false
    },
    questions: {
      type    : Array,
      default : () => ([])
    },
    content: {
      type    : Object,
      default : () => ({})
    },
    attempt: {
      type    : Object,
      default : () => ({})
    },
    totalQuizPoints: {
      type    : Number,
      default : null
    }
  },
  mixins     : [QuizMixin],
  components : {
    QuestionsSummary,
    HtmlRenderContainer
  },
  data() {
    return {
    };
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        renderFormulas(this);
      }
    }
  },
  computed: {
    ...mapGetters({
      getterSelectedTopic: 'plataforma/enrollment/getterSelectedTopic'
    })
  },
  methods: {
    closeModal() {
      this.$emit('close-summary-modal');
    }
  }
};
